namespace advisorop.components.servicer {

    class ServicerDashboardController {
        //public advisorId;
        $router;
        user: domains.identity.IUser;

        PeriodicWithIssuesCount: number;
        PeriodicDepIssuesCount: number;
        NonzeroFundingIssuesCount: number;
        CashMonitorIssuesCount: number;
        OrionHighCashModelMonitorIssuesCount: number;
        OrionHighCashNonModelMonitorIssuesCount: number;
        NegcashMonitorIssuesCount: number;
        UncategorizedSecuritiesMonitorIssuesCount: number;
        systemStatus: domains.ISystemStatus[];

        isAServicerAdmin: boolean;
        public isAServicerOperation: boolean = false;
        isNotATrader: boolean = false;

        static $inject = ["identityService", "servicerService", "$window"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService, private $window: any) {

        }

        companyGroupChanged(id: number): void {
            //this.advisorId = id;
        };

        loadLocalWidgets(): void {

            var sysStatus: domains.ISystemStatus[];
            // Get system status
            this.servicerService.getSystemStatus().then(response => {
                console.log("RESPONSE:", response);
                this.systemStatus = response.data;
            });

            // Other local adds can go here
        }

        isTrader(): boolean {
            return (this.user.role == domains.AdvisoryRoles.SERVICER_TRADER.toString());
        }

        $onInit(): void {
            //this.advisorId = 1;
            
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                console.log(`User role is ${this.user?.role}`);
                this.isAServicerAdmin = (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString());
                this.isAServicerOperation = (this.user.role == domains.AdvisoryRoles.SERVICER_OPERATIONS.toString());
                this.isNotATrader = !this.isTrader();
                this.loadLocalWidgets();
            });
        }

        $routerOnActivate(next, previous) {
        }
    }



    class ServicerDashboard implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ServicerDashboardController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/servicer-dashboard.html';
        }
    }
    angular.module(Constants.APP).component("servicerDashboard", new ServicerDashboard());


}